import { render } from "./SajatOsszes.vue?vue&type=template&id=7b36a35d&scoped=true"
import script from "./SajatOsszes.vue?vue&type=script&lang=js"
export * from "./SajatOsszes.vue?vue&type=script&lang=js"

import "./SajatOsszes.vue?vue&type=style&index=0&id=7b36a35d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b36a35d"]])

export default __exports__